import styles from "../styles/pages/Dashboard.module.scss";

import empty from "../assets/images/empty.svg";
import search from "../assets/icons/search.svg";
import word_icon from "../assets/icons/file_types/word_icon.svg";
import pdf_icon from "../assets/icons/file_types/pdf_icon.svg";
import excel_icon from "../assets/icons/file_types/excel_icon.svg";
import mail_icon from "../assets/icons/file_types/mail_icon.svg";
import text_icon from "../assets/icons/file_types/text_icon.svg";
import unknown_icon from "../assets/icons/file_types/unknown_icon.svg";
import powerpoint_icon from "../assets/icons/file_types/powerpoint_icon.svg";

import { format, isValid, parseISO } from "date-fns";

import { Input } from '../components/ui/input'
import { Button, useWindowSize } from "@qastanfit/qastan-ui"
import { useAppDispatch, useAppSelector } from "../hooks/redux";
import { MutableRefObject, useEffect, useRef, useState } from "react";

import ResponsiveMasonry from "react-responsive-masonry"
import { setFavoriteDocuments, setNotification } from "../redux/actions";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { useNavigate } from "react-router-dom";
import FilePreview from "../components/files/FilePreview";
import Actions from "../components/dashboard/Actions";
import useAuth from "src/hooks/useAuth";
import axios from "src/axios/axios";
import { File, Heart, Search } from "lucide-react";
import { ScrollArea, ScrollBar } from "src/components/ui/scroll-area";
import { useTranslation } from "react-i18next";
import { getWindevLang } from "src/lib/lang";
import OpenCommunication from "src/components/dashboard/OpenCommunication";
import { Toaster } from "react-hot-toast";
import { CONFIG } from "src/config";
import OneDrive from "src/components/dashboard/onedrive/main";




export default function Dashboard(){
    const {t, i18n} = useTranslation()
    const message = [t("Goede morgen"), t("Goede middag"), t("Goede avond")]
    const {auth} = useAuth()
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const favoriteDocuments:DocumentObject[] = useSelector((state:RootState) => state.favoriteDocuments)
    const metatypes:MetatypeObject[] = useSelector((state:RootState) => state.metatypes)
    const doctypes:DoctypeObject[] = useSelector((state:RootState) => state.doctypes)
    const actions:Action[] = useSelector((state:RootState)=>state.actions);

    const [show_filepreview, setshow_filepreview] = useState<boolean>(false);
    const [selectedDocument, setselectedDocument] = useState<DocumentObject>();

    const fastSearchValue = useRef('')

    const returnMessage = () => {
        let d = new Date();
        if(d.getHours() < 12){
            return message[0]
        }
        else if(d.getHours() >= 12 && d.getHours() < 18){
            return message[1]
        }
        else {
            return message[2]
        }
    }

    const {width, height} = useWindowSize();

    const handleDeleteFavorite = async (item:DocumentObject) => {
        let {data:res} = await axios.delete(`favorites/delete?docid=${item.docid}`)
        if(res.errorcode === 0){
            let tmp_f = [...favoriteDocuments];
            const i = tmp_f.findIndex(i => i.docid.toString() === item.docid.toString())
            if(i > -1){
                tmp_f.splice(i, 1)
                dispatch(setFavoriteDocuments(tmp_f))
                dispatch(setNotification({type:'success', title:'Succces', message:t('Uit favorieten verwijderd')}))
            }
        }
        else {
            //Failed to delete favorite
            dispatch(setNotification({type:'error', title:'Error', message:t('Uit favorieten verwijderen mislukt')}))
        }
    }

    const extensionToIcon = (extension:string) => {
        switch (extension) {
            case 'doc': case 'docx' :
                return word_icon
            case 'xlsx':
                return excel_icon
            case 'pdf':
                return pdf_icon
            case 'txt':
                return text_icon
            case 'ppt':
                return powerpoint_icon
            case 'eml':
                return mail_icon;
            default:
                return unknown_icon
        }
    }

    const enterSearch = (e:React.KeyboardEvent<HTMLInputElement>) => {
        if(e.key === "Enter"){
            navigate(`zoeken?v=${fastSearchValue.current}`)
        }
    }

    return (
        <>
            <Toaster />

            {(show_filepreview && selectedDocument) && 
                <FilePreview document={selectedDocument} onClose={()=>{setshow_filepreview(false)}}/>
            }

            <div className={styles.dashboard}>
                <div className={styles.bg_image}></div>

                <div className={styles.content}>
                    <div className={styles.top_content}>
                        <h1 className='text-3xl font-bold text-white'>{returnMessage()}, {auth.data?.user.name}!</h1>
                        <p className='text-sm text-white uppercase'>{format(new Date(), "EEEE, d MMMM yyyy")}</p>
                    </div>

                    <div className='flex flex-col items-center justify-center gap-4 p-8 bg-white border rounded-lg shadow-sm'>
                        <h2 className='text-2xl font-semibold'>{t('Snel zoeken')}</h2>

                        <Input onChange={(e)=>{fastSearchValue.current = e.currentTarget.value}} onKeyDown={(e)=>{enterSearch(e)}} className="w-full max-w-lg rounded-full" startEnhancer={<Search className="w-4 h-4 text-neutral-400" strokeWidth={1.5} />} placeholder={`${t('Zoek een document in FitDoc')}...`}/>

                    </div>

                    <div className="flex flex-col gap-10 mt-10">
                        <div>
                            <h3 className="mb-2 font-semibold text-neutral-600">{t('Favoriete documenten')}</h3>
                            <div>
                                {favoriteDocuments && 
                                <>
                                    {favoriteDocuments.length > 0 
                                    ?
                                    <ScrollArea>
                                    <div className="flex gap-3">
                                    {favoriteDocuments.map((document, index)=>(
                                        <div onClick={()=>{setshow_filepreview(true); setselectedDocument(document)}} key={index} className="border min-w-[255px] w-[255px] overflow-hidden rounded-md group">
                                            <div className="h-[100px] bg-neutral-100 border-b flex items-end justify-center pt-3 px-3 relative">
                                                <button onClick={()=>{handleDeleteFavorite(document)}} className="absolute top-1.5 right-1.5"><Heart className="w-4 h-4 text-blue-500 duration-300 fill-blue-500 hover:fill-blue-100"/></button>
                                                <div className="bg-white rounded-t-md p-2 w-[150px] h-full shadow-sm border border-b-0 flex flex-col gap-1">
                                                    <div className="w-5 h-1 rounded-full bg-neutral-100"></div>
                                                    <div className="w-10 h-1 rounded-full bg-neutral-100"></div>
                                                    <div className="w-10 h-1 rounded-full bg-neutral-100"></div>
                                                    <div className="w-20 h-1 rounded-full bg-neutral-100"></div>
                                                    <div className="w-5 h-1 rounded-full bg-neutral-100"></div>
                                                    <div className="w-10 h-1 rounded-full bg-neutral-100"></div>
                                                    <div className="w-10 h-1 rounded-full bg-neutral-100"></div>
                                                    <div className="w-20 h-1 rounded-full bg-neutral-100"></div>
                                                    <div className="w-5 h-1 rounded-full bg-neutral-100"></div>
                                                </div>
                                            </div>
                                            <div className="p-2 w-[255px] overflow-hidden flex flex-col gap-1 bg-white h-full group-hover:bg-blue-100 duration-200 cursor-pointer">
                                                <div className="flex items-center gap-2">
                                                    <img className='w-5 h-5' src={extensionToIcon(document.filename.split('.')[1])} alt="file type"/>
                                                    <p className="text-neutral-600 text-sm line-clamp-1 font-semibold truncate w-[200px] group-hover:text-blue-500">{doctypes?.find(dt=>dt.doctype===document.doctype)?.docoms.find(i=>i.nationid===getWindevLang(i18n.language))?.oms || document.doctype}</p>
                                                </div>
                                                <p className='text-xs text-neutral-400'>{document.docdate && isValid(parseISO(document.docdate)) && format(parseISO(document.docdate), "d MMM yyyy")}</p>
                                                <div className="flex flex-wrap items-center gap-1">
                                                    {document.metadata.filter(md=>metatypes.find(mt=>mt.metatype===md.metatype)?.required).map((md, id)=>(
                                                        <div className='bg-neutral-50 text-xs rounded-[7px] px-1 py-0.5 group-hover:bg-blue-200' key={id}>{metatypes.find(m=>m.metatype===md.metatype)?.metatype_oms.find(o=>o.nationid===getWindevLang(i18n.language))?.oms}:{md.metavalue}</div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    </div>
                                    <ScrollBar orientation="horizontal"/>
                                    </ScrollArea>
                                    :
                                    <div className='flex flex-col items-center justify-center p-4 bg-white border rounded-lg'>
                                        <img className='w-[150px] mb-2' src={empty} alt="Empty" /> 
                                        <p className='font-medium text-center text-neutral-600'>{t('Geen favoriete documenten')}</p>
                                        <p className='text-sm text-center text-neutral-400'>{t('Voeg documenten toe aan uw favorieten om ze hier terug te vinden')}</p>
                                    </div>
                                    }
                                </>
                                }
                            </div>
                        </div>
                        
                        {actions && 
                        <div>
                            {actions.length > 0 &&
                                <Actions />
                            }
                        </div>
                        }

                        <div className="flex flex-wrap gap-10">
                            <OpenCommunication openDocument={(d) => { setselectedDocument(d); setshow_filepreview(true) }}/>

                            {CONFIG.onedrive.enable && <OneDrive />}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}